import { useState } from 'react';

interface UseModalStateReturn {
  modalState: Record<string, boolean>;
  openModal: (key: string) => void;
  closeModal: (key: string) => void;
  toggleModal: (key: string) => void;
  isModalOpen: (key: string) => boolean;
}

export const useModalState = (): UseModalStateReturn => {
  const [modalState, setModalState] = useState<Record<string, boolean>>({});

  const openModal = (key: string) => {
    setModalState(prev => ({ ...prev, [key]: true }));
  };

  const closeModal = (key: string) => {
    setModalState(prev => ({ ...prev, [key]: false }));
  };

  const toggleModal = (key: string) => {
    setModalState(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const isModalOpen = (key: string) => modalState[key] || false;

  return {
    modalState,
    openModal,
    closeModal,
    toggleModal,
    isModalOpen
  };
};
